import logsApi from '../_api'
export default {
  fetchLogs: async ({ commit, dispatch, getters }, logEntity) => {
    if (getters.isCallingLogs || !logEntity) return
    try {
      const page = getters.currentPage
      commit('setIsCallingLogs', true)
      let response = {}
      switch (logEntity) {
        case 'office':
          response = await logsApi.getOfficeLog(page)
          break
        case 'users':
          response = await logsApi.getUsersLog(page)
          break
        case 'cards':
          response = await logsApi.getCardsLog(page)
          break
        case 'webhook':
          response = await logsApi.getWebHookLogs(page)
          break
      }

      commit('setLogs', response.data)
      commit('setLogsLastPage', response.headers['pagination-last-page'])
      commit('setLogsTotalItems', response.headers['pagination-total-items'])
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'fetch_log_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingLogs', false)
    }
  },
  nextLogsPage: ({ commit, dispatch }, logEntity) => {
    if (!logEntity) return
    commit('incrementLogsCurrentPage')
    dispatch('fetchLogs', logEntity)
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
